import { PayloadAction } from '@reduxjs/toolkit';

import { SnapSiteConfigState } from '../initial-state';
import type { WritableSnapSiteConfigStore } from '../slice';

export function setSnapSiteConfig(
  _state: WritableSnapSiteConfigStore,
  action: PayloadAction<SnapSiteConfigState>,
) {
  return action.payload;
}
